import { useQuery } from "@tanstack/react-query"
import { endOfDay, isValid, startOfDay } from "date-fns"
import { useMemo } from "react"

import scheduleApi from "./scheduleApi"

const useChineseNewYearQuery = () => {
  const { data: result } = useQuery(["scheduleApi.chineseNewYear"], scheduleApi.chineseNewYear)

  const interval = useMemo(() => {
    const [start, end] = result?.isSuccess ? result.data : []
    if (start && end) {
      const startDate = startOfDay(start)
      const endDate = endOfDay(end)

      if (isValid(startDate) && isValid(endDate)) {
        return [startDate, endDate] as const
      }
    }

    return [null, null] as const
  }, [result])

  return interval
}

export default useChineseNewYearQuery
